import React from 'react';

import { Link } from '@rover/kibble/core';
import { CustomHelperMessageWrapper } from '@rover/kibble/forms/fields/sharedTypography';
import useFooterShim from '@rover/shared/js/hooks/useFooterShim';

const EmailHelperMessage: React.FC<{
  helperMessageId: string;
}> = ({ helperMessageId }) => {
  const { footer } = useFooterShim();
  const { emailCapture } = footer || {};
  if (!emailCapture) return null;
  return (
    <CustomHelperMessageWrapper helperMessageId={helperMessageId}>
      {emailCapture.items.length > 0 && (
        <Link href={emailCapture.items[0].url} variant="secondary" size="100" asInlineLink>
          {emailCapture.items[0].name}
        </Link>
      )}
    </CustomHelperMessageWrapper>
  );
};

export default EmailHelperMessage;
